import fetcher from '../../utils/fetcher';
import type { StartOtpResponse, VerifyOtpResponse } from './types';

export async function postLoginOtpStart(email: string, captchaToken: string) {
  const res = await fetcher(
    `${process.env.REACT_APP_API_URL}/login/otp/start`,
    'POST',
    { email, captchaToken },
    null,
  ) as StartOtpResponse;
  return { registered: res.data.registered };
}

export async function postLoginOtpVerify(email: string, code: string) {
  const res = await fetcher(
    `${process.env.REACT_APP_API_URL}/login/otp/verify`,
    'POST',
    { email, code },
    null,
  ) as VerifyOtpResponse;
  return {
    id: res.data.id,
    token: res.data.token,
    email: res.data.email,
    firstName: res.data.firstName,
    role: res.data.role,
    hasAddress: res.data.hasAddress,
    hasLoan: res.data.hasLoan,
    hasInvestment: res.data.hasInvestment,
    identificationId: res.data.identificationId,
  };
}
